export enum ReturnStatus {
  ERROR = 'ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

export interface Return<T> {
  status: ReturnStatus;
  response: T;
}
